module.exports = "<a class=\"phone\" ng-href=\"{{ 'tel:+' + $ctrl.number }}\">\r\n    {{ $ctrl.number | tel : { showCountry: $ctrl.showCountry } }}\r\n</a>";